import { SubAPI } from "./SubAPI";
export class Library extends SubAPI {
    clear(props) { return this.fetcher.post("/api/hardware-library/clear", props); }
    get(props) { return this.fetcher.get("/api/hardware-library", props); }
    copyFromProject(props) { return this.fetcher.post("/api/hardware-library/copy", props); }
    upsert(props) { return this.fetcher.post("/api/hardware-library", props); }
    upsertShortcode(props) { return this.fetcher.post("/api/hardware-library/shortcode", props); }
    getShortCodes(input) { return this.fetcher.get("/api/hardware-library/shortcodes", input); }
}
